import { useCallback, useEffect, useState } from 'react'

const EXPANDED_KEY = 'spectre:nav:expanded'

function readBool(key: string, fallback = false): boolean {
  if (typeof window === 'undefined') return fallback
  try {
    const v = window.localStorage.getItem(key)
    if (v === null) return fallback
    return v === 'true'
  } catch {
    return fallback
  }
}

function writeBool(key: string, value: boolean): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(key, String(value))
  } catch {
    /* ignore */
  }
}

export interface NavShellState {
  expanded: boolean
  setExpanded: (v: boolean) => void
  toggleExpanded: () => void
}

export function useNavShellState(): NavShellState {
  const [expanded, setExpandedState] = useState<boolean>(() => readBool(EXPANDED_KEY, false))
  useEffect(() => writeBool(EXPANDED_KEY, expanded), [expanded])
  const toggleExpanded = useCallback(() => setExpandedState(v => !v), [])
  return { expanded, setExpanded: setExpandedState, toggleExpanded }
}
